// Adresses publiques des fronts (app/, admin/) et du site vitrine (site/), pour
// les liens de l'un vers l'autre. Sans dépendance serveur : importable côté client
// (les PUBLIC_* sont inlinées au build des fronts).

export const APP_URL = (process.env.PUBLIC_APP_URL || "http://localhost:3120").replace(/\/$/, "");
export const ADMIN_URL = (process.env.PUBLIC_ADMIN_URL || "http://localhost:3121").replace(/\/$/, "");
export const SITE_URL = (process.env.PUBLIC_SITE_URL || "http://localhost:4321").replace(/\/$/, "");
